// removed by extract-text-webpack-plugin
module.exports = {"header_user":"_3lzT2gkM7kAOTewSZYsduJ","ant-avatar":"_2Wvm0F-3MBENpTaL5tFk-u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Settings/Dashboard/dashboard_wrapper.css
// module id = 3054
// module chunks = 0